const newUser = resolve => require(["@/pages/newUser/index.vue"], resolve);
const createBase = resolve => require(["@/pages/newUser/create/base.vue"], resolve);
const createSet = resolve => require(["@/pages/newUser/create/set.vue"], resolve);
const createFinish = resolve => require(["@/pages/newUser/create/finish.vue"], resolve);
const newUserDetail = resolve => require(["@/pages/newUser/detail.vue"], resolve);



export default [
    /****************会员管理***************/
    {
        path: "/newUser",
        name: "活动列表",
        component: newUser,
        meta: {
            keepAlive: true
        }
    },
    {
        path: "/newUser/createBase",
        name: "活动详情",
        component: createBase,
       
    },
    {
        path: "/newUser/createSet",
        name: "活动详情",
        component: createSet,
       
    },{
        path: "/newUser/createFinish",
        name: "活动详情",
        component: createFinish,
        
    },{
        path: "newUserDetail",
        name: "活动详情",
        component: newUserDetail,
    },
   
   
];
